import { useState, useEffect } from "react";

/**
 * useDebounce
 *
 * A custom hook that helps optimize network queries.
 * It internally manages the value state and returns both its immediate version
 * (so inputs respond instantly) and its delayed version
 * (to execute the query only when the user finishes typing).
 */
export const useDebounce = (initialValue, delay = 500) => {
  const [value, setValue] = useState(initialValue);

  const [debouncedValue, setDebouncedValue] = useState(initialValue);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return { value, debouncedValue, setValue };
};
